import React, {useContext, useState} from "react";
import cn from "classnames";
import styles from "./Burn.module.sass";
import Loader from "../Loader";
import {message} from "antd";
import {Web3Context} from "../../contexts/Web3Context";
import {getContracts} from "../../adapters/eth";

message.config({top: 100, duration: 5, maxCount: 3,});

const Burn = ({className, item, onOutsideClick}) => {

    const [inProcess, setInProcess] = useState(false);

    const {web3, defaultAccount} = useContext(Web3Context)

    const burnIt = async (event) => {
        event.preventDefault();
        setInProcess(true);

        try {
            const contracts = await getContracts(web3);

            contracts.Nft.methods.burn(item.token_id)
                .send({from: defaultAccount})
                .once('receipt', () => {
                    setInProcess(false);
                    message.success('Done');
                    window.location.reload();
                })
                .on('error', e => {
                    console.log(e);
                    message.error('Error when burn token!');
                    setInProcess(false);
                    return false;
                });
        } catch (e) {
            console.log(e);
            message.error('Error when burn token!');
            setInProcess(false);
            return false;
        }
    };

    return (
        <div className={cn(className, styles.transfer)}>
            <div className={cn("h4", styles.title)}>Burn token</div>
            <div className={styles.text}>
                Are you sure to burn this token? This action cannot be undone. Token
                will be transferred to zero address
            </div>
            <div className={styles.btns}>
                <button className={cn("button", styles.button)} onClick={burnIt}>
                    {inProcess ?
                        <Loader className={styles.loader} color="white"/> :
                        'Burn'
                    }
                </button>
                <button className={cn("button-stroke", styles.button)} onClick={onOutsideClick}>Cancel</button>
            </div>
        </div>
    );
};

export default Burn;
